import { ICellRendererParams } from 'ag-grid-community'
import capitalize from 'lodash/capitalize'

export const capitalizeRenderer =
  (propName: string) => (props: ICellRendererParams<{ [propName: string]: string }>) => {
    return capitalize(props.data?.[propName])
  }
